import { useMemo } from "react";
import { Box } from "@mui/material";
import PropTypes from "prop-types";
import styles from "./Logo.module.css";

const Logo = ({
  className = "",
  logo2Height,
  logo2Width,
  logo2AlignSelf,
  logo2Flex,
  logo2Position,
  logo2Top,
  logo2Left,
  onLogo2ContainerClick,
  logo3Width,
  group,
  group1,
}) => {
  const logo2Style = useMemo(() => {
    return {
      height: logo2Height,
      width: logo2Width,
      alignSelf: logo2AlignSelf,
      flex: logo2Flex,
      position: logo2Position,
      top: logo2Top,
      left: logo2Left,
    };
  }, [
    logo2Height,
    logo2Width,
    logo2AlignSelf,
    logo2Flex,
    logo2Position,
    logo2Top,
    logo2Left,
  ]);

  const logo3Style = useMemo(() => {
    return {
      width: logo3Width,
    };
  }, [logo3Width]);

  return (
    <Box
      className={[styles.logo2, className].join(" ")}
      style={logo2Style}
      onClick={onLogo2ContainerClick}
    >
      <Box className={styles.logo3} style={logo3Style}>
        <img className={styles.groupIcon} loading="lazy" alt="" src={group} />
        <img className={styles.groupIcon1} loading="lazy" alt="" src={group1} />
      </Box>
    </Box>
  );
};

Logo.propTypes = {
  className: PropTypes.string,
  group: PropTypes.string,
  group1: PropTypes.string,

  /** Style props */
  logo2Height: PropTypes.string,
  logo2Width: PropTypes.string,
  logo2AlignSelf: PropTypes.string,
  logo2Flex: PropTypes.string,
  logo2Position: PropTypes.string,
  logo2Top: PropTypes.string,
  logo2Left: PropTypes.string,
  logo3Width: PropTypes.string,

  /** Action props */
  onLogo2ContainerClick: PropTypes.func,
};

export default Logo;
